export default __webpack_public_path__ + "src/docs/packages/summerfields-rose-retreat.pdf";